const PREFIX = 'APP'

export const APP_INIT = `${PREFIX}_INIT`
export const APP_SHOW_ALERT = `${PREFIX}_SHOW_ALERT`
export const APP_HIDE_ALERT = `${PREFIX}_HIDE_ALERT`
export const APP_INIT_ROUTE_SET = `${PREFIX}_INIT_ROUTE_SET`